import { CheckCircle2 } from 'lucide-react';
import { Button } from './Button';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

interface PricingCardProps {
  title: string;
  price: string;
  description: string;
  features: string[];
  featured?: boolean;
  buttonText?: string;
}

export const PricingCard = ({
  title,
  price,
  description,
  features,
  featured = false,
  buttonText = "Começar agora"
}: PricingCardProps) => {
  return (
    <div className={cn(
      "relative p-8 rounded-[2.5rem] transition-all duration-500 hover:-translate-y-2",
      featured 
        ? "bg-slate-900 text-white shadow-2xl scale-105 border-2 border-[#D4AF37] z-10" 
        : "bg-white text-slate-900 border border-slate-100 shadow-xl"
    )}>
      
      {featured && (
        <div className="absolute -top-5 left-1/2 -translate-x-1/2 gold-gradient text-white px-6 py-1 rounded-full text-sm font-bold tracking-wide uppercase shadow-lg">
          Mais Popular
        </div>
      )}

      <div className="mb-8">
        <h3 className={cn(
          "text-2xl font-extrabold mb-2",
          featured ? "text-white" : "text-slate-800"
        )}>
          {title}
        </h3>
        <p className={featured ? "text-slate-400" : "text-slate-500"}>
          {description}
        </p>
      </div>

      <div className="mb-8">
        <span className="text-5xl font-black">{price}</span>
        <span className={cn(
          "text-sm ml-2",
          featured ? "text-slate-400" : "text-slate-500"
        )}>
          /único
        </span>
      </div>

      <ul className="space-y-4 mb-10">
        {features.map((feature, index) => (
          <li key={index} className="flex items-start gap-3">
            <CheckCircle2 className={cn(
              "shrink-0 mt-0.5",
              featured ? "text-[#D4AF37]" : "text-emerald-500"
            )} size={20} />
            <span className={featured ? "text-slate-300" : "text-slate-600"}>
              {feature}
            </span>
          </li>
        ))}
      </ul>

      <Button 
        variant={featured ? "primary" : "outline"}
        className="w-full py-4 text-lg"
      >
        {buttonText}
      </Button>
    </div>
  );
};